import React from 'react';
import { IDocument, IField, ITrainingSet, IGroundTruth } from '../../../types/my-types';
import useDocGen from '../../hooks/useDocGen';
import useTokenized from '../../hooks/useTokenized';
import useTokenizedUrl from '../../hooks/useTokenizedUrl';
import MarkContent from './MarkContent';

export interface MarkDocProps {
  doc: IDocument;
  fields: IField[];
  groundTruths: IGroundTruth[];
  trainingSet: ITrainingSet;
}

const MarkDoc: React.FC<MarkDocProps> = ({ doc, fields, trainingSet, groundTruths }) => {
  const defaultUrl = doc?.tokenizeds ? doc?.tokenizeds[doc?.tokenizeds.length - 1] : '';
  const tokenizedUrl = useTokenizedUrl(defaultUrl, doc?.id, trainingSet.tokenizer_version);

  const tokenPages = useTokenized(tokenizedUrl, doc?.id, doc?.label, false, trainingSet.id);
  const currentDoc = useDocGen(doc?.id);

  if (!Array.isArray(tokenPages)) {
    return tokenPages;
  }
  if (!currentDoc.hasOwnProperty('id')) {
    return currentDoc as JSX.Element;
  }
  // TODO: filter groundtruths by page

  if (currentDoc.hasOwnProperty('id') && Array.isArray(tokenPages)) {
    return (
      <>
        <MarkContent
          doc={currentDoc as IDocument}
          fields={fields}
          groundTruths={groundTruths}
          tokenPages={tokenPages}
        />
      </>
    );
  } else {
    return null;
  }
};

export default MarkDoc;
